import CouponControls from "./CouponControls";
import TutorialCard from "./TutorialCard";

function TutorialsSection(props) {
  const { tutorials } = props;

  return (
    <>
      <div className="yourprod-header">
        <h3>Tutorials</h3>

        <CouponControls category="tutorial" {...props} />
      </div>

      <div className="products-grid">
        {tutorials.map((tutorial) => (
          <TutorialCard key={tutorial.$id} tutorial={tutorial} {...props} />
        ))}
      </div>
    </>
  );
}

export default TutorialsSection;
